import Item from "@/lib/model/breadcrumb/item";

const breadcrumbs: { [key: string]: Item[] } = {
  "paper-info": [
    { name: "返回面试列表", path: "exam/paper" },
    { name: "新建面试", isGo: true }
  ],
  "paper-info-sf": [
    { name: "返回面试列表", path: "exam/paper-sf" },
    { name: "新建面试", isGo: true }
  ],
  "paper-bgcheck": [
    { name: "返回面试列表", path: "exam/paper" },
    { name: "背调设置", showTip: true }
  ],
  //编辑面试-已选题目页面
  "paper-edit": [
    { name: "返回面试列表", path: "exam/paper" },
    { name: "编辑题目" }
  ],
  //从题库选题页面
  "question-store": [
    { name: "返回面试列表", path: "exam/paper" },
    { name: "编辑面试", path: "-1" },
    { name: "选题" }
  ],
  "question-paper": [
    { name: "返回面试列表", path: "exam/paper" },
    { name: "编辑题目" }
  ],
  "question-paper-sf": [
    { name: "返回面试列表", path: "exam/paper-sf" },
    { name: "编辑题目" }
  ],
  "exam-paperList": [
    { name: "返回面试列表", path: "/exam/paper" },
    { name: "候选人列表", param: "paper-list" }
  ],
  "exam-paperList-sf": [
    { name: "返回面试列表", path: "/exam/paper-sf" },
    { name: "候选人列表", param: "paper-list" }
  ],
  "exam-candidates": [
    { name: "返回面试列表", path: "/exam/list" },
    { name: "面试详情" }
  ],
  "ask-paper": [
    { name: "返回面试列表", path: "exam/paper" },
    { name: "调查问卷结果统计" }
  ]
};
export default breadcrumbs;
